__turbopack_context__.v({
  "legalDialog": "my-legal-dialogs-module__D-XB6q__legalDialog",
  "legalDialogClose": "my-legal-dialogs-module__D-XB6q__legalDialogClose",
  "legalDialogHeader": "my-legal-dialogs-module__D-XB6q__legalDialogHeader",
  "legalDialogScroll": "my-legal-dialogs-module__D-XB6q__legalDialogScroll",
  "legalDialogTitle": "my-legal-dialogs-module__D-XB6q__legalDialogTitle",
});
